import { render, staticRenderFns } from "./Draws.vue?vue&type=template&id=4b9d3666&scoped=true"
import script from "./Draws.vue?vue&type=script&lang=js"
export * from "./Draws.vue?vue&type=script&lang=js"
import style0 from "./Draws.vue?vue&type=style&index=0&id=4b9d3666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d3666",
  null
  
)

export default component.exports